import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import StoreFilters from './store';
import StoriesFilters from './stories';
import MediaFilters from './media';
import Filter from 'common/components/responsive/filter';

const ContentFilters = ({
   resources,
   hiddeClearFilters = true,
   isAuthUser = true,
   contentType,
   filters,
   primaryColor,
   onFilterChange,
   isMobile,
   clearAllFilters,
}) => {
   const filtersProps = {
      onFilterChange: onFilterChange,
      isMobile: isMobile,
      filters: filters,
   }
   return (
      <>
         {
            'store' === contentType && (
               <StoreFilters
                  { ...filtersProps }
                  categories={ resources?.categories }
               />
            )
         }
         {
            'story' === contentType && (
               <StoriesFilters
                  { ...filtersProps }
                  primaryColor={ primaryColor }
               />
            )
         }
         {
            ['video', 'recorded_stream', 'photoset'].includes(contentType) && (
               <MediaFilters
                  isAuthUser={ isAuthUser }
                  resources={ resources }
                  collectionsKey={ contentType === 'photoset' ? 'photoset_collections' : 'video_collections' }
                  { ...filtersProps }
               />
            )
         }

         {
            !hiddeClearFilters && 'story' !== contentType && (
               <div className='h-10 inline-block ml-2 mr-4 whitespace-nowrap'>
                  <Button
                     text='Clear all'
                     textColor='secondary dark:text-secondary-dark'
                     backgroundColor='transparent'
                     textSize='base'
                     onClick={ clearAllFilters }
                     classNames='h-full px-2 flex items-center'
                     padding='none'
                     iconName='cancel'
                     fontIconColor='secondary'
                     darkIconColor='secondary-dark'
                     fontIconSize='large'
                     iconPosition='left'
                  />
               </div>
            )
         }
      </>
   )
};


const MultipleFilter = ({
   selectedValue = [],
   onFilterChange,
   name,
   data,
   filterClassName = '!flex-none',
   isMobile,
   ...rest
}) => {
   return (
      <Filter
         desktopType={ isMobile ? 'mobile' : 'descktop' }
         name={ name }
         data={ data }
         filterClassName={ filterClassName }
         type='filter'
         className='border rounded-lg'
         isAutoSave
         activeSelectedValue={ { value: selectedValue, name: selectedValue?.length ? `${ selectedValue?.length } Selected` : null } }
         contentStyles={ {
            maxWidth: '320px',
            top: '44px',
         } }
         padding='px-4'
         height='10'
         isMultiplSelect
         onClickClear={ () =>  onFilterChange(null) }
         onFilterChange={ (value, name, bool) => onFilterChange(value) }
         isSearchable={ data && data.length > 10 }
         { ...rest }
      />
   )
}

MultipleFilter.propTypes = {
   selectedValue: PropTypes.array,
   onFilterChange: PropTypes.func,
   name: PropTypes.string,
   filterClassName: PropTypes.string,
   data: PropTypes.array,
   isMobile: PropTypes.bool,
};
ContentFilters.propTypes = {
   storeCategories: PropTypes.array,
   resources: PropTypes.object,
   onFilterChange: PropTypes.func,
   contentType: PropTypes.string,
   isMobile: PropTypes.bool,
   filters: PropTypes.object,
   primaryColor: PropTypes.bool,
   hiddeClearFilters: PropTypes.bool,
   isAuthUser: PropTypes.bool,
   clearAllFilters: PropTypes.func,
};

export default ContentFilters;
export { MultipleFilter };
